import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=1cbc6750&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=ts&"
export * from "./VideoCard.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=1cbc6750&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc6750",
  null
  
)

export default component.exports